import api from "./api";

export function getSixbellSorDefaultParameters() {
  return new Promise((resolve, reject) => {
    api
      .get("/sixbell-sor-default-parameters")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getById(id) {
  return new Promise((resolve, reject) => {
    api
      .get(`/sixbell-sor-default-parameters/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function update(values) {
  return new Promise((resolve, reject) => {
    api({
      method: "put",
      url: `/sixbell-sor-default-parameters`,
      data: values,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
